import React from "react";
import "./BadgeList.css"; // Import the standard CSS file

const badges = [
  {
    id: 1,
    title: "Fiqh Flamebearer",
    subtitle: "Beginner - Islamic Jurispudence on Finance",
    description:
      "Awarded for beginning your study into Islamic Financial Jurisprudence, recognizing your pure intention (Niyyah) to seek lawful wealth.",
    image: "/fiqhflame.png",
  },
  {
    id: 2,
    title: "Shariah Sentinel",
    subtitle: "Graduate - Islamic Jurispudence on Fiance",
    description:
      "Granted to the Initiate who has established their foundation in the sources (Uṣūl) and basic rulings of financial transactions, where ethics meet enterprise.",
    image: "/shariahsentinel.png",
  },
  {
    id: 3,
    title: "Free Market Novice",
    subtitle: "Beginner - Principles of Austrian Economics",
    description:
      "Awarded for embarking on the path of economic reason. You've established the foundational insight that economics begins with purposeful human action and individual choice.",
    image: "/freemarketnovice.png",
  },
  {
    id: 4,
    title: "Praxeology Practitioner",
    subtitle: "Graduate - Principles of Austrian Economics",
    description:
      "Honors the graduate who has mastered the a priori logic of human action and its consequences. You can now confidently apply the laws of time preference, capital structure, and sound money to analyze market phenomena.",
    image: "/praxeologypractitioner.png",
  },
  {
    id: 5,
    title: "Scarcity Seeker",
    subtitle: "Beginner - The Apex Asset",
    description:
      "Awarded for initiating the quest for absolute scarcity. You've begun questioning the integrity of traditional assets (gold, stocks, real estate) and exploring the fundamental nature of lasting value.",
    image: "/scarcityseeker.png",
  },
  {
    id: 6,
    title: "Bitcoin Believer",
    subtitle: "Graduate - The Apex Asset",
    description:
      "Honors the graduate who has mastered the Apex Asset thesis. You can now articulate why assets lacking immutability and true scarcity are fundamentally inferior to Bitcoin in the digital age.",
    image: "/bitcoinbeliever.png",
  },
   {
    id: 7,
    title: "Central Bank Critic",
    subtitle: "Beginner - Review of Comtemporary Financial Institutes",
    description:
      "Awarded for initiating your study into the mechanics of centralized finance. You've begun questioning the legitimacy of fiat currency, fractional reserve banking, and the inflationary mandate of central banks.",
    image: "/centralbankcritic.png",
  },
   {
    id: 8,
    title: "Monetary Policy Archtect",
    subtitle: "Graduate - Review of Comtemporary Financial Institutes",
    description:
      "Honors your Monetary Intelligence. You have mastered the arguments against monetary debasement and possess the knowledge to audit central bank policies, advocate for sound money, and protect wealth from inflationary decay.",
    image: "/monetarypolicyarchitect.png",
  },
    {
    id: 9,
    title: "Riba Renouncer",
    subtitle: "Beginner - Bitcoin Guide for Muslims",
    description:
      "Awarded for initiating your Riba Inquiry. You've recognized the imperative to seek money that is structurally just and have begun the legal and technical investigation into Bitcoin's Sharīʿah compliance.",
    image: "/ribarenouncer.png",
  },
    {
    id: 10,
    title: "Halal Hodler",
    subtitle: "Graduate - Bitcoin Guide for Muslims",
    description:
      "Honors your juhd to master the Bitcoin Protocol. You have achieved a deep understanding of how this asset's underlying structure guarantees absolute scarcity and is engineered to disallow unjust gain. You are now fully competent to analyze its compatibility with Islamic ethics for modern trade and wealth preservation.",
    image: "/halalhodler.png",
  },
   {
    id: 11,
    title: "Bitcoin Navigator",
    subtitle: "Beginner - Fundamentals of Bitcoin Technology",
    description: "Awarded for beginning your journey into the technical world of Bitcoin. You've started understanding how transactions, network rules, and digital scarcity come together to create a robust monetary system.",
    image: "/bitcoinnavigator.png"
  },
  {
    id: 12,
    title: "Bitcoin Technologist",
    subtitle: "Graduate - Fundamentals of Bitcoin Technology",
    description: "Honors the graduate who has mastered the fundamentals of Bitcoin’s technical architecture. You now understand how decentralized consensus, proof-of-work, and digital integrity maintain a secure and scarce monetary network.",
    image: "/bitcointechnologist.png"
  },
  {
  id: 13,
  title: "Lightning Pathfinder",
  subtitle: "Beginner – Fundamentals of the Lightning Network",
  description:
    "Awarded for taking your first steps beyond Bitcoin’s base layer. You have begun understanding payment channels, off-chain transactions, and why Layer Two solutions are essential for scalability without compromising sound money principles.",
  image: "/lightningpathfinder.png",
},
{
  id: 14,
  title: "Layer Two Strategist",
  subtitle: "Graduate – Fundamentals of the Lightning Network",
  description:
    "Honors your understanding of Bitcoin’s Layer Two architecture. You can now analyze routing, liquidity management, channel design, and the strategic role of the Lightning Network in enabling fast, low-cost payments while preserving Bitcoin’s decentralized base layer.",
  image: "/layertwostrategist.png",
},
{
  id: 15,
  title: "Sovereign Apprentice",
  subtitle: "Beginner – Sovereign Skills Lab",
  description:
    "Awarded for taking the first steps toward financial self-sovereignty. You have begun learning hands-on skills such as secure key management, hardware wallets, and operating independently without trusted intermediaries.",
  image: "/sovereignapprentice.png",
},
{
  id: 16,
  title: "Trustless Infrastructure Builder",
  subtitle: "Graduate – Sovereign Skills Lab",
  description:
    "Honors mastery of practical Bitcoin sovereignty. You are capable of running infrastructure, securing wealth through offline key generation, operating miners or nodes, and building systems that eliminate reliance on centralized trust.",
  image: "/trustlessinfrastructurebuilder.png",
}
];

export default function BadgeList() {
  return (
    <div className="page-container">
      <div
        className="content-wrapper"
      >
        <h1 className="main-title">
         Course Badges
        </h1>

        {badges.map((badge, index) => (
          <div key={badge.id}>
            <div className="badge-card">
              
              {/* RIGHT SIDE: Image and Title stack */}
              <div className="badge-image-title-column">
                <img
                  src={badge.image}
                  alt={badge.title}
                  className="badge-image"
                />
                <h2 className="badge-title">
                  {badge.title}
                </h2>
                <p className="badge-subtitle">
                  {badge.subtitle}
                </p>
              </div>

              {/* LEFT SIDE: Description Text */}
              <div className="badge-description-column">
                <p className="badge-description">
                  {badge.description}
                </p>
              </div>
            </div>

            {/* SEPARATOR LINE */}
            {index < badges.length - 1 && (
              <div
                className="separator-container"
              >
                <div className="separator-line"></div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}